import { LinkModel, LinksGroupModel } from "../domain/LinksGroupModel";
import { LnCollapseGroup } from "../../components/LnCard/LnCollapseGroup";
import { SortableContext, useSortable } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';
import { DragHandle } from "../../components/DragHandle/DragHandle";
import classes from "./links.module.scss";
import { UniqueIdentifier } from "@dnd-kit/core";
import { useDialog } from "src/components/Modalservice/Dialogservice";
import AddLinkDialog from "./AddLinkDialog";
import coursePartService from "../CoursePartService";
import LnIcon from "src/components/LnIcon";
import { useI18n } from "src/utils/lni18n";
import { LinkCard } from "./LinkCard";
import { useInput } from "src/components/Modalservice/UseInput";
import { useConfirm } from "src/components/Modalservice/UseConfirm";

export default function LinkGroup(props: {
    group: LinksGroupModel, closed?: boolean,
    active?: UniqueIdentifier, dragged?: boolean, partId: string
}) {

    const { group, closed, dragged, active, partId } = props;
    const dialogPortal = useDialog();
    const { languageService: t } = useI18n();
    const input = useInput();
    const confirm = useConfirm();

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id: group.Id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: dragged ? "75%" : ""

    };

    const dummyLink: LinkModel = {
        Id: "dummy_" + group.Id,
        Url: "",
        Description: ""
    }

    const addOrEditLink = (data?: LinkModel) => {

        dialogPortal({
            factory: (onSubmit, onCancel) => {

                return <AddLinkDialog data={data} onCancel={onCancel} onSubmit={onSubmit} />
            },
            size: "md"
        }).then((data: LinkModel) => {
            if( data)
                coursePartService.saveOrUpdateLink(partId, group.Id, data);
        }).catch((e: Error) => {/* ok to swallow */ });
    }

    const deleteLink = (id: string) => {

        confirm("md", t.getText("delete"),
                <div className="preserve-white" >{t.getText("link.delete.link.warning")}</div>)
        .then((res: boolean) => {
            if (res) {
                coursePartService.deleteLink(partId, group.Id, id);
            }
        }).catch((e: Error) => {/* ok to swallow */});
    }

    const deleteGroup = () => {
        confirm("md", t.getText("delete"),
                <div className="preserve-white" >{t.getText("sure_to_delete")}</div> )
        .then((res: boolean) => {
            if (res) {
                coursePartService.deleteLinkGroup({ partId, groupId: group.Id });
            }
        }).catch((e: Error) => {/* ok to swallow */});
    }

    const editGroup = () => {

        input(t.getText("edit"), <div>{t.getText("name")}</div>, group.Name)
            .then((name: string) => {
                if (name !== "") {
                    coursePartService.renameLinkGroup({ name, groupId: group.Id, partId: partId! })
                }
            }).catch((e: Error) => { });
    }

    const name = <> {group.Name}{group.Links.length > 0 ? <LnIcon name="slides" className="ms-3 mt-2 icon-small" /> : <></>}</>

    const actionButtons = <>

        {group.IsDefault == false && <>
            <button className="btn btn-link mx-3" type="button" onClick={editGroup}>
                <LnIcon name="edit" className="icon-small" />
            </button>
            <button className="btn btn-link mx-3" type="button" onClick={deleteGroup}>
                <LnIcon name="delete" className="icon-small" />
            </button>
        </>
        }
    </>;

    const handle = group.IsDefault ? <div></div> :
        <div className={classes.dragHandle} {...attributes} {...listeners}><DragHandle /></div>;
    const panel = <LnCollapseGroup actionButton={actionButtons}
        className={active === group.Id ? classes.active : ""}
        groupName={name} isOpen={!closed} handle={handle} >

        <SortableContext items={group.Links.map(l => l.Id)} id={group.Id}>

            <div className="text-end mb-3">
                <button onClick={() => addOrEditLink()} className={`btn btn-small btn-primary`}>{t.getText("add.link")}</button>
            </div>

            <div>
                {group.Links.map((item) => (
                    <LinkCard deleteLink={deleteLink} edit={(l) => addOrEditLink(l)} active={active} key={item.Id} link={item} />
                ))}
                <LinkCard deleteLink={() => { }} edit={(l) => { }} key={dummyLink.Id} link={dummyLink} dummy={true} />
            </div>
        </SortableContext >
    </LnCollapseGroup>;

    return <>{group.IsDefault ?
        <div id={"g_" + group.Id} role="listitem" key={group.Id} className="mb-4" >{panel}</div>
        :
        <div ref={setNodeRef} style={style} id={"g_" + group.Id} role="listitem" key={group.Id} className="mb-4" >
            {panel}
        </div>}
    </>
}